(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nouralume-specials-banner"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => {
    document.querySelectorAll('[data-nl-offers]').forEach(banner => {
      if (banner.dataset.initialized) return;
      banner.dataset.initialized = 'true';
      const button = banner.querySelector('.nl-offers__toggle');
      button.addEventListener('click', () => {
        const paused = banner.classList.toggle('is-paused');
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? button.dataset.resumeLabel : button.dataset.pauseLabel);
        button.querySelector('[data-nl-offers-icon]').textContent = paused ? '▶' : 'Ⅱ';
      });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

})();
